import {
	transformUser,
	transformSharePermission,
} from '@atlassian/jira-common-directory-v2/src/services/transformers.tsx';
import type { Filter } from '../model/index.tsx';
import type { Filter as RestFilter } from '../rest/types.tsx';

export const transformFilter = (item: RestFilter): Filter => ({
	id: item.id,
	name: item.name,
	viewUrl: `/issues/?filter=${item.id}`,
	owner: item.owner ? transformUser(item.owner) : null,
	isFavourite: item.favourite,
	popularity: item.favouritedCount || 0,
	shares: item.sharePermissions
		? item.sharePermissions.map(transformSharePermission).filter(Boolean)
		: [],
	edits: item.editPermissions
		? item.editPermissions.map(transformSharePermission).filter(Boolean)
		: [],
	description: item.description,
	jql: item.jql,
	isWritable: item.isWritable === true,
});
